import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'invoices',
            name: 'invoice',
            class: 'Modules\\Ecommerce\\Entities\\Invoice',

            validatingRFC: false
        }
    },

    methods: {
        validateRFC(rfc) {
            this.validatingRFC = true

            axios({
                method: 'post',
                url: route('api.invoices.validateRFC'),
                data: {rfc: rfc}
            })
            .then(response => {
                if(response.data.success) {
                    this.$alert('RFC Válido', 'Listo!', 'success')
                } else {
                    this.$alert(response.data.message, 'Error!', 'error')
                }
            })
            .catch(error => {
                this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error')
                this.validatingRFC = false
            })
            .finally(
                () => this.validatingRFC = false
            )
        }
    }
}